import { render, staticRenderFns } from "./placeholder-img.vue?vue&type=template&id=e4f737d4&scoped=true&"
import script from "./placeholder-img.vue?vue&type=script&lang=js&"
export * from "./placeholder-img.vue?vue&type=script&lang=js&"
import style0 from "./placeholder-img.vue?vue&type=style&index=0&id=e4f737d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f737d4",
  null
  
)

export default component.exports